<template>


  <v-app>
    <v-app-bar v-if="settingsLoaded" :color="getSettings.primaryColor" elevation="2">
      <div
          style="max-width: 750px; width: 100%; height: inherit"
          class="mx-auto d-flex align-center justify-left"
      >
        <v-img
            :src="settingsLoaded ? getSettings.courseLogo : 'Laddar...'"
            height="70%"
            max-width="100px"
            style="height: 70%"
        />
        <v-app-bar-title
            :class="'pl-4 text-center ' + toggleMobileTitle"
            :style="{ color: getSettings.fontColor + ' !important' }"
        >
          {{ settingsLoaded ? getSettings.pageTitle : 'Laddar...' }}
        </v-app-bar-title>

        <div style="width: 100px" class="d-flex align-center justify-end">
          <v-btn
              v-if="$route.name !== 'HomeView' && isUserLoggedIn"
              size="x-small"
              class="text-right no-uppercase"
              prepend-icon="mdi-account"
              :style="{ color: getSettings.fontColor + ' !important', 'min-width': '130px'}"
              stacked
              :disabled="!isUserLoggedInToCustomerPortalApi"
              @click="$router.push({ name: 'InformationView' })"
          >
            <span class="user-name">{{ getFullName ? getFullName : 'Logga ut' }}</span>
          </v-btn>
          <v-dialog v-model="dialog" max-width="300">
            <v-card>
              <v-card-title class="bg-primary">Logga ut</v-card-title>

              <v-card-text class="pa-2 d-flex align-center" style="min-height: 70px">
                Är du säker du vill logga ut?
              </v-card-text>

              <v-card-actions>
                <v-btn
                    :color="getSettings.primaryColor"
                    :style="{ color: getSettings.fontColor + ' !important' }"
                    class="no-uppercase"
                    text="Nej, stanna"
                    variant="elevated"
                    @click="dialog = false"
                />

                <v-spacer></v-spacer>

                <v-btn
                    class="no-uppercase"
                    :color="getSettings.primaryColor"
                    :style="{ color: getSettings.fontColor + ' !important' }"
                    variant="elevated"
                    text="Ja"
                    @click="goToFrontpage"
                />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </v-app-bar>

    <v-app-bar v-else-if="!settingsLoaded" :color="getSettings.primaryColor" elevation="2">
      <sync-loader :loading="settingsLoaded" :color="getSettings.primaryColor" size="15px"/>
    </v-app-bar>

    <v-main>
      <v-container
          v-if="loading"
          class="justify-center d-flex align-center"
          style="height: 50%; max-width: 750px"
      >
        <sync-loader :loading="loading" :color="getSettings.primaryColor" size="15px"/>
      </v-container>
      <v-container v-else style="max-width: 750px">
        <router-view/>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'

export default {
  name: 'App',
  components: {
    SyncLoader
  },
  data() {
    return {
      dialog: false,
      loading: true,
      settingsLoaded: false,
      userLoggedIn: false
    }
  },
  computed: {
    primaryColor() {
      return process.env.VUE_APP_PRIMARY_COLOR
    },
    toggleMobileTitle() {
      if (this.$vuetify.display.xs) return 'gron-kurs-mobile-app-bar-title'

      return 'gron-kurs-app-bar-title'
    },
    isUserLoggedIn() {
      return this.getUserLoggedIn
      // return localStorage.getItem('UserLoggedIn')
    },
    isUserLoggedInToCustomerPortalApi() {
      return this.getUserLoggedInToCustomerPortalApi
    },
    ...mapGetters({
      getPageGroup1: 'getPageGroup1',
      getPageGroup2: 'getPageGroup2',
      getPageGroup3: 'getPageGroup3',
      getPageGroup4: 'getPageGroup4',
      getCriiptoIdentifier: 'getCriiptoIdentifier',
      getSettings: 'getSettings',
      getSystemSettings: 'getSystemSettings',
      getFullName: 'getFullName',
      getUserLoggedInToCustomerPortalApi: 'getUserLoggedInToCustomerPortalApi',
      getUserLoggedIn: 'getUserLoggedIn'
    })
  },
  async created() {
    await this.fetchSettings().then(() => {
      this.settingsLoaded = true

      // Set the document title from settings
      if (this.getSettings && this.getSettings.pageTitle) {
        document.title = this.getSettings.pageTitle
      }
    })

    await this.fetchSettingPages().then(() => {
      if (
          !this.getPageGroup1 ||
          !this.getPageGroup2
      ) {
        this.$router.push({name: 'ErrorView'})
      }
      this.loading = false
    })

    await this.fetchSystemSettings().then(() => {
      localStorage.setItem(
          'systemSettings',
          JSON.stringify(this.getSystemSettings)
      )

      const enableBusinessLogin = this.getSystemSettings && this.getSystemSettings.enableBusinessLogin
      if (enableBusinessLogin === false) {
        this.setUserLoggedIn(true)
      }
    })
  },
  methods: {
    goToFrontpage() {
      this.dialog = false
      // Reset login state on logout
      localStorage.removeItem('UserLoggedIn')
      this.userLoggedIn = false
      this.$router.push({name: 'HomeView'})
    },
    ...mapActions({
      fetchPages: 'fetchPages',
      fetchSettings: 'fetchSettings',
      fetchSettingPages: 'fetchSettingPages',
      fetchSystemSettings: 'fetchSystemSettings',
      setUserLoggedIn: 'setUserLoggedIn',
    })
  }
}
</script>
